import { Inbox } from 'lucide-react';

// Jednotný empty state pro prázdné tabulky, nevybrané detail panely atd.
// Použití:
//   <EmptyState title="Žádné kalibrace ke schválení" />
//   <EmptyState icon={FlaskConical} title="Vyberte kalibraci" description="Klikněte..." />
//   <EmptyState title="..." action={<Button>...</Button>} size="lg" />

const SIZES = {
  sm: { padding: 'py-6', iconBox: 'w-10 h-10 p-2', icon: 'w-6 h-6' },
  md: { padding: 'py-12', iconBox: 'w-14 h-14 p-3', icon: 'w-8 h-8' },
  lg: { padding: 'py-20', iconBox: 'w-20 h-20 p-4', icon: 'w-12 h-12' },
};

export default function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  size = 'md',
  className = '',
}) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex flex-col items-center justify-center text-center ${s.padding} ${className}`}>
      {Icon && (
        <div
          className={`rounded-full mb-4 flex items-center justify-center ${s.iconBox}`}
          style={{ background: 'var(--ct-bg-secondary)' }}
        >
          <Icon className={s.icon} style={{ color: 'var(--ct-text-disabled)' }} />
        </div>
      )}
      {title && <h3 className="ct-h3 mb-1">{title}</h3>}
      {description && (
        <p className="text-sm max-w-sm" style={{ color: 'var(--ct-text-secondary)' }}>
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
